import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getAccountingAccess(token) {
  const res = await axios.get(`${API}/accounting/access`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingBookingStatus(token) {
  const res = await axios.get(`${API}/accounting/booking-status`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingProfile(token) {
  const res = await axios.get(`${API}/accounting/profile`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateAccountingProfile(token, payload) {
  const res = await axios.put(`${API}/accounting/profile`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingChecklist(token) {
  const res = await axios.get(`${API}/accounting/checklist`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingDocuments(token) {
  const res = await axios.get(`${API}/accounting/documents`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingDocumentRequests(token) {
  const res = await axios.get(`${API}/accounting/requests`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingActivity(token, params = {}) {
  const res = await axios.get(`${API}/accounting/activity`, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

export async function getAccountingReviewSummary(token) {
  const res = await axios.get(`${API}/accounting/review/summary`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingStripePriceAudit(token) {
  const res = await axios.get(`${API}/accounting/review/stripe-price-audit`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingSourceData(token, params = {}) {
  const res = await axios.get(`${API}/accounting/source-data`, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

export async function downloadAccountingSourceDataExport(token, params = {}) {
  const res = await axios.get(`${API}/accounting/source-data/export`, {
    headers: authHeaders(token),
    params,
    responseType: "blob",
  });
  return res;
}

export async function createAccountingDocumentUploadUrl(token, payload) {
  const res = await axios.post(`${API}/accounting/documents/upload-url`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function completeAccountingDocumentUpload(token, documentId) {
  const res = await axios.post(
    `${API}/accounting/documents/complete-upload`,
    { document_id: documentId },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function deleteAccountingDocument(token, documentId) {
  const res = await axios.delete(`${API}/accounting/documents/${documentId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listAccountingReviewDocuments(token, params = {}) {
  const res = await axios.get(`${API}/accounting/review/documents`, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

export async function createAccountingReviewDocumentRequest(token, payload) {
  const res = await axios.post(`${API}/accounting/review/requests`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateAccountingReviewDocument(token, documentId, payload) {
  const res = await axios.patch(
    `${API}/accounting/review/documents/${documentId}`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getAccountingReviewDocumentDownloadUrl(token, documentId) {
  const res = await axios.get(
    `${API}/accounting/review/documents/${documentId}/download-url`,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
